export const CBT_GET_MULTIPLE =  "CBT_GET_MULTIPLE"
export const CBT_GET_DROPDOWNS =  "CBT_GET_DROPDOWNS"
export const CBT_GET_ONE =  "CBT_GET_ONE"
export const CBT_SET_ONE =  "CBT_SET_ONE"
export const CBT_REGISTER_SUCCESS =  "CBT_REGISTER_SUCCESS"
export const CBT_REGISTER_FAIL =  "CBT_REGISTER_FAIL"
export const CBT_LOADING =  "CBT_LOADING"
export const CBT_LOADING_ERROR =  "CBT_LOADING_ERROR"
export const CBT_ACTIVATE_FAIL =  "CBT_ACTIVATE_FAIL"
export const CBT_ACTIVATE_SUCCESS =  "CBT_ACTIVATE_SUCCESS"
export const CBT_UPDATE_SUCCESS =  "CBT_UPDATE_SUCCESS"
export const CBT_UPDATE_FAIL =  "CBT_UPDATE_FAIL"
export const CBT_DELETE_SUCCESS =  "CBT_DELETE_SUCCESS"
export const CBT_DELETE_FAIL =  "CBT_DELETE_FAIL"
export const CBT_EDIT =  "CBT_EDIT"